import { Card, Text, Grid, Divider, Stack, Tooltip } from "@mantine/core";
import React from "react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { dateWithHourFormat } from "../../../../utils/dateFormat";

function Details({
  id,
  date,
  rule,
  tenant,
  author,
}) {
  const { t } = useTranslation();
  const gridBreakpoints = { base: 12, sm: 5, md: 3 };

  const DetailsSection = ({ title, value }) => (
    <Grid gap="lg">
      <Grid.Col pr={0} span={5}>
        <Text c="gray.6" size="sm">
          {title}:
        </Text>
      </Grid.Col>
      <Grid.Col p={0} span={7}>
        {React.isValidElement(value) ? (
          value
        ) : (
          <Tooltip label={value} disabled={!value}>
            <Text truncate="end" size="sm">
              {value || "-"}
            </Text>
          </Tooltip>
        )}
      </Grid.Col>
    </Grid>
  );

  return (
    <Card bg="gray.1">
      <Text mb="md" fw={500}>
        {t("flagDetails.details.title")}
      </Text>
      <Grid w={"100%"} align="center">
        <Grid.Col miw={280} span={gridBreakpoints}>
          <Stack gap={4}>
            <DetailsSection
              title={t("flagDetails.details.flaggedDate")}
              value={date ? dayjs(date).format(dateWithHourFormat) : "-"}
            />
            <DetailsSection title={t("flagDetails.details.flag")} value={id} />
          </Stack>
        </Grid.Col>

        <Divider orientation="vertical" />
        <Grid.Col miw={280} span={gridBreakpoints}>
          <Stack gap={4}>
            <DetailsSection
              title={t("flagDetails.details.rule")}
              value={rule}
            />
            <DetailsSection
              title={t("flagDetails.details.tenant")}
              value={tenant}
            />
          </Stack>
        </Grid.Col>

        <Divider orientation="vertical" />
        <Grid.Col
          miw={280}
          span={gridBreakpoints}
          style={{ alignSelf: "flex-start" }}
        >
            <DetailsSection
              title={t("flagDetails.details.author")}
              value={author}
            />
        </Grid.Col>
      </Grid>
    </Card>
  );
}

export default Details;
